import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clinic-dashboard-search-noresult',
  templateUrl: './clinic-dashboard-search-noresult.component.html',
  styleUrls: ['./clinic-dashboard-search-noresult.component.scss'],
})
export class ClinicDashboardSearchNoresultComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
